import { BitrixVue } from "ui.vue";

BitrixVue.component("ConfigBlockWrapTitle", {
	props: ["state", "tippyContent"],

	template: `
		<div class="config-block__wrap-title">
			<slot></slot>
			<span v-if="this.tippyContent" class="tooltip-question">
				<ui-tooltip position="bottom" animation="fade">{{ this.tippyContent }}</ui-tooltip>
			</span>
		</div>
`,
});
